import {
  type ExpenseTypeEnum,
  useLatestExpenseInternalNumberQuery,
} from "@src/__generated__/graphql";

export const useFetchLatestInternalNumber = (
  type?: ExpenseTypeEnum,
): string | undefined | null => {
  const { data } = useLatestExpenseInternalNumberQuery();

  if (!type) return undefined;

  const internalNumber = data?.getLatestExpenseInternalNumberPerType?.find(
    (i) => i.type === type,
  );

  return internalNumber?.internal_number;
};
